import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "25",
  cy: "25.5",
  r: "25",
  fill: "#40AE42"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21.6733 30.675L16.8948 26.0361C16.3623 25.5192 15.5158 25.5192 14.9833 26.0361C14.4509 26.553 14.4509 27.3748 14.9833 27.8917L20.704 33.445C21.2364 33.9619 22.0966 33.9619 22.6291 33.445L37.1013 19.4092C37.6338 18.8923 37.6338 18.0706 37.1013 17.5537C36.5688 17.0368 35.7223 17.0368 35.1899 17.5537L21.6733 30.675Z",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "50",
    height: "51",
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass($props.className)
  }, _hoisted_3, 2))
}